// extracted by mini-css-extract-plugin
export default {"loader":"Form_loader__5l9gF","spin":"Form_spin__X1R3n"};